/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdChannelsChannelid200,
  GetApiV1ClassroomdisciplineIdChannelsChannelid401,
  GetApiV1ClassroomdisciplineIdChannelsChannelid404,
  GetApiV1ClassroomdisciplineIdChannelsChannelidPathParams,
  GetApiV1ClassroomdisciplineIdChannelsChannelidQueryResponse,
} from "../../types/classPlanningChannelsController/GetApiV1ClassroomdisciplineIdChannelsChannelid.ts";
import { channelDetailViewModelSchema } from "../channelDetailViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdChannelsChannelidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChannelsChannelidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdChannelsChannelid200Schema = z.lazy(
  () => channelDetailViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChannelsChannelid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdChannelsChannelid401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdChannelsChannelid404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChannelsChannelid404>;

export const getApiV1ClassroomdisciplineIdChannelsChannelidQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdChannelsChannelid200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChannelsChannelidQueryResponse>;
